'use strict';

const { countLocationConflicts } = require('./countLocationConflicts.js');
const { cropImage } = require('../../../../pmtPlacesApp/subscriptions/imageSubscriptions.js');

function Controller(
	$scope,
	$stateParams,
	auth,
	enabledNetworks,
	locationDataService,
	pmtElmService,
	pmtEnvService,
	$http,
	$timeout,
	$rootScope,
	pmtSiteInfoService
) {
	const site = $stateParams.site;
	const placeId = $stateParams.placeId;
	this.site = site;
	this.selectedSite = auth.user.selectedSite;
	this.placeId = placeId;
	this.isAdmin = auth.user.isAdmin;

	this.allowMediaReview = auth.user.selectedSite.places?.feature?.allowMediaReview?.enabled;
	Object.assign(this, enabledNetworks.get());

	const getLocationInfo = (place, selectedSite) => {
		const siteCategories = {
			google: {
				additional: selectedSite?.places?.google?.categories?.additionalCategories,
				primary: selectedSite?.places?.google?.categories?.primaryCategory
			},
			apple: {
				additional: selectedSite?.places?.apple?.categories?.additionalCategories,
				primary: selectedSite?.places?.apple?.categories?.primaryCategory
			},
			facebook: {
				subcategories: selectedSite?.places?.facebook?.subcategories
			},
			bing: selectedSite?.places?.bing
		};

		const brandMedia = {
			google: selectedSite?.places?.google?.media,
			facebook: selectedSite?.places?.facebook?.media
		};

		return {
			location: {
				storeId: place.storeId,
				name: place.name,
				shortDescription: place.shortDescription,
				longDescription: place.longDescription,
				isActive: place.isActive,
				isAlwaysOpen: place.isAlwaysOpen,
				permanentlyClosed: place.permanentlyClosed,
				temporarilyClosedUntil: place.temporarilyClosedUntil || '',
				address: place.address,
				contact: place.contact,
				coordinates: place.location,
				id: place.id,
				apple: place.apple,
				bing: place.bing,
				facebook: place.fb,
				google: place.google,
				factual: place.factual,
				ptv: place.ptv,
				type: place.type,
				networkCategories: place.networkCategories,
				siteCategories,
				networkAttributes: place.networkAttributes,
				actionLinks: place.actionLinks,
				brandMedia,
				openHours: place.openHours
			},
			siteNetworks: {
				google: !!selectedSite?.analytics?.google?.enabled,
				facebook: !!selectedSite?.analytics?.facebook?.enabled,
				bing: !!selectedSite?.analytics?.bing?.enabled,
				apple: !!selectedSite?.analytics?.apple?.enabled,
				factual: !!selectedSite?.analytics?.factual?.enabled,
				overture: !!selectedSite?.analytics?.overture?.enabled,
				here: !!selectedSite?.analytics?.here?.enabled,
				tomtom: !!selectedSite?.analytics?.tomtom?.enabled,
				ptv: !!selectedSite?.analytics?.ptv?.enabled
			},
			today: new Date().toISOString().split('T')[0],
			siteName: selectedSite.name,
			requestUrl: pmtEnvService.insightsApiUrl
		};
	};

	const prepareUserForPinMeToPage = user => {
		const localAccess = { ...user.localAccess };
		localAccess.roles = localAccess.roles ? [...localAccess.roles.values()] : [];
		localAccess.permissions = localAccess.permissions ? [...localAccess.permissions.values()] : [];
		return {
			...user,
			localAccess: localAccess
		};
	};

	const getAppleCategories = site_ => site_?.places?.apple;
	const getBingCategories = site_ => site_?.places?.bing;
	const getFacebookCategories = site_ => site_?.places?.facebook;
	const getFoursquareCategories = site_ => ({ categories: site_?.places?.factual?.categories });
	const getHereCategories = site_ => site_?.places?.here?.categories;
	const getOvertureCategories = site_ => site_?.places?.overture?.categories;
	const getTomtomCategory = site_ => site_?.places?.tomtom?.category;

	const getCategories = site_ => {
		if (!site_) {
			return;
		}

		return {
			apple: getAppleCategories(site_),
			bing: getBingCategories(site_),
			facebook: getFacebookCategories(site_),
			factual: getFoursquareCategories(site_),
			overture: getOvertureCategories(site_),
			here: getHereCategories(site_),
			tomtom: getTomtomCategory(site_)
		};
	};

	pmtSiteInfoService.subscribeToWork(msg => {
		if (msg && msg.work) {
			$timeout(() => {
				pmtElmService.sendData(
					'Location.DetailsPage.Main',
					msg.work.success
						? 'in_Location_Details_Main_workSucceeded'
						: 'in_Location_Details_Main_workFailed',
					{ workId: msg.work.id, locationIds: msg.work.locationIds }
				);
			});
		}
	});

	const bindPlace = res => {
		this.place = res.data;
		const isGoogleEnabled =
			this.selectedSite?.analytics?.google?.enabled &&
			this.selectedSite.networkConnections?.google?.connected &&
			(this.place.google?.idSetType === 'approved' ||
				(this.place.google?.idSetType === 'userAction' && !this.place.google?.data?.isDuplicate));
		const isFacebookEnabled =
			this.selectedSite?.analytics?.facebook?.enabled &&
			this.selectedSite.networkConnections?.facebook?.connected &&
			this.place.fb?.idSetType === 'approved';
		const isBingEnabled = this.selectedSite?.analytics?.bing?.enabled;
		const isPtvEnabled = this.selectedSite?.analytics?.ptv?.enabled;
		const isAppleEnabled =
			this.selectedSite?.analytics?.apple?.enabled &&
			['approved', 'userAction'].includes(this.place.apple?.idSetType);

		this.place.addressIsVerified = !!res.data.verification?.addressAndCoordinates?.status;
		this.place.serviceAreasAreVerified = !!res.data.verification?.serviceAreas?.status;
		this.hasConflict = countLocationConflicts(site, this.place, {
			google: isGoogleEnabled,
			facebook: isFacebookEnabled,
			bing: isBingEnabled,
			ptv: isPtvEnabled,
			apple: isAppleEnabled
		});

		this.detailsPageArgs = {
			...getLocationInfo(this.place, this.selectedSite),
			user: prepareUserForPinMeToPage(auth.user),
			locationId: this.placeId,
			analytics: this.selectedSite.analytics,
			categories: getCategories(this.selectedSite),
			initialPath: window.location.pathname
		};
	};

	const sectionIds = [
		'general-data',
		'address',
		'open-hours',
		'contact-information',
		'attributes-and-services',
		'images',
		'categories',
		'custom-fields'
	];
	let scrollHandler = null;
	let lastReportedSection = null;

	const teardownSectionObserver = () => {
		if (scrollHandler) {
			window.removeEventListener('scroll', scrollHandler);
			scrollHandler = null;
		}
		lastReportedSection = null;
	};

	// The side-pane map is a non-interactive thumbnail (click opens a popup), so
	// its MapLibre zoom/rotate controls are dead weight. The map renders inside
	// the pmt-map-v2 web component's open shadow root, out of reach of our app
	// CSS and with no attribute to disable the controls, so inject a scoped style
	// into the shadow root. The popup map (a separate pmt-map-v2) keeps its
	// controls. Retry briefly: the element and its shadow root may not exist yet
	// when the side pane mounts.
	const hideSidePaneMapNavControls = () => {
		let attempts = 0;
		const inject = () => {
			const mapEl = document.querySelector('.location-info-pane__map--shadow pmt-map-v2');
			const root = mapEl?.shadowRoot;
			if (root) {
				if (!root.querySelector('style[data-pmt-hide-map-nav]')) {
					const style = document.createElement('style');
					style.setAttribute('data-pmt-hide-map-nav', '');
					style.textContent = '.maplibregl-ctrl-group { display: none; }';
					root.appendChild(style);
				}
				return;
			}
			if (attempts++ < 50) {
				setTimeout(inject, 100);
			}
		};
		inject();
	};

	const setupSectionObserver = () => {
		teardownSectionObserver();
		if (!window.location.pathname.includes('/details')) {
			return;
		}

		const reportSection = () => {
			let current = null;
			for (const id of sectionIds) {
				const el = document.getElementById(id);
				if (el && el.getBoundingClientRect().top <= 10) {
					current = id;
				}
			}
			if (current && current !== lastReportedSection) {
				lastReportedSection = current;
				pmtElmService.sendData(
					'Location.DetailsPage.Main',
					'in_Location_LocationInfoPane_Main_OnScrolledToSection',
					current
				);
				// Double rAF: run after Elm has re-rendered the __active class.
				requestAnimationFrame(() =>
					requestAnimationFrame(() => {
						const active = document.querySelector('.location-info-pane-navigation__active');
						if (active) {
							active.scrollIntoView({ block: 'nearest' });
						}
					})
				);
			}
		};

		scrollHandler = reportSection;
		window.addEventListener('scroll', reportSection, { passive: true });
		reportSection();
	};

	const updateTitleBar = value => {
		if (this.titleBarValue !== value) {
			this.titleBarValue = value;
			const doc = document.body.getElementsByClassName('pmt-location-top-info');
			if (doc[0]) {
				if (value.isActive && doc[0].classList.contains('pmt-location-top-info--disabled')) {
					doc[0].classList.remove('pmt-location-top-info--disabled');
				} else if (
					!value.isActive &&
					!doc[0].classList.contains('pmt-location-top-info--disabled')
				) {
					doc[0].classList.add('pmt-location-top-info--disabled');
				}
			}
		}
	};

	this.detailsPageSubscriptions = [
		{
			id: 'CopyToClipboard',
			port: 'out_Location_Details_Main_CopyToClipboard',
			f: value => {
				navigator.clipboard.writeText(value);
			}
		},
		{
			id: 'OpenGoogleQRCode',
			port: 'out_Location_Details_Main_OpenGoogleQRCode',
			f: ([siteName, locationId]) => {
				if (siteName && locationId) {
					let url = `/listings/api/${siteName}/place/${locationId}/google/qrcode/newreview`;
					window.open(url, '_blank');
				}
			}
		},
		{
			id: 'UpdateTitleBar',
			port: 'out_Location_Details_Main_UpdateTitleBar',
			f: updateTitleBar
		},
		{
			id: 'UpdateTitleBarAngular',
			port: 'out_Location_Details_Main_UpdateTitleBarAngular',
			f: updateTitleBar
		},
		cropImage(
			pmtElmService,
			{
				id: 'CropImage',
				port: 'out_Location_Details_Main_CropImage',
				elmModule: 'Location.DetailsPage.Main',
				capturedPort: 'in_Location_Details_Main_onImageCaptured'
			},
			document
		),
		{
			id: 'AddWork',
			port: 'out_Location_Details_Main_AddWork',
			f: () => pmtSiteInfoService.addWork()
		},
		{
			id: 'SendScrollToSection',
			port: 'out_Location_LocationInfoPane_Main_SendScrollToSection',
			f: navItemId => {
				pmtElmService.sendData(
					'Location.DetailsPage.Main',
					'in_Location_Details_Main_scrollToSection',
					navItemId
				);
			}
		},
		{
			id: 'OnSidePanelMounted',
			port: 'out_Location_LocationInfoPane_Main_OnSidePanelMounted',
			f: () => {
				pmtElmService.sendData(
					'Location.DetailsPage.Main',
					'in_Location_LocationInfoPane_Main_OnLocationChanged',
					window.location.pathname
				);
				setupSectionObserver();
				hideSidePaneMapNavControls();
			}
		}
	];

	const getLocationProperties = (site_, placeId_) => {
		$http.get(`api/${encodeURI(site_)}/place/${placeId_}/properties`).then(res => {
			const properties = res.data;
			this.unreviewedMediaCount = properties.unreviewedMediaCount;
		});
	};

	$scope.clearNewMediaBadge = () => {
		this.unreviewedMediaCount = 0;
	};

	locationDataService.get(site, placeId).then(bindPlace);
	getLocationProperties(site, placeId);
	locationDataService.subscribe(site, placeId, 'pmtLocation', bindPlace);

	this.unregister = [
		$scope.$watch(
			() => {
				return window.location.pathname;
			},
			(newArgs, oldArgs) => {
				// update info pane when location properties update
				if (oldArgs && !angular.equals(newArgs, oldArgs)) {
					pmtElmService.sendData(
						'Location.DetailsPage.Main',
						'in_Location_LocationInfoPane_Main_OnLocationChanged',
						newArgs
					);
					setupSectionObserver();
				}
			}
		)
	];
	this.$onDestroy = () => {
		this.unregister?.forEach(i => i());
		teardownSectionObserver();
	};
}

angular.module('pmtPlacesApp.controllers').component('pmtLocation', {
	templateUrl: 'components/location/pmtLocation.html',
	controller: Controller
});
Controller.$inject = [
	'$scope',
	'$stateParams',
	'auth',
	'pmtEnabledNetworksService',
	'pmtLocationDataService',
	'pmtElmService',
	'pmtEnvService',
	'$http',
	'$timeout',
	'$rootScope',
	'pmtSiteInfoService'
];
